// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.ListInput {
    border: 1px solid var(--border-color);
    background-color: var(--list-bg-color);
    padding: 0.25em;
    width: 100%;
    min-height: 2em;
}

div.list-input-value {
    display: flex;
}

div.list-input-value > :first-child {
    flex: 1 1 auto;
}

div.list-input-value > span.icon-trash {
    padding-left: 0.25em;
}

div.list-input-value > span.icon-trash:hover {
    color: red;
}

div.list-input-add > button {
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./qwc2/components/widgets/style/ListInput.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,sCAAsC;IACtC,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf","sourcesContent":["div.ListInput {\n    border: 1px solid var(--border-color);\n    background-color: var(--list-bg-color);\n    padding: 0.25em;\n    width: 100%;\n    min-height: 2em;\n}\n\ndiv.list-input-value {\n    display: flex;\n}\n\ndiv.list-input-value > :first-child {\n    flex: 1 1 auto;\n}\n\ndiv.list-input-value > span.icon-trash {\n    padding-left: 0.25em;\n}\n\ndiv.list-input-value > span.icon-trash:hover {\n    color: red;\n}\n\ndiv.list-input-add > button {\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
